import Layout from '@/layout'

const doPayRouter = {
  path: '',
  component: Layout,
  redirect: 'dopay',
  name: 'DoPay钱包',
  meta: {
    title: 'DoPay钱包',
    icon: 'el-icon-s-home'
  },
  children: [
    {
      path: 'dopay',
      name: 'dopay',
      meta: {
        title: 'DoPay钱包'
      },
      component: () => import('@/views/index')
    },
    {
      path: 'dopay/rechargeBankQuick',
      name: 'rechargeBankQuick',
      meta: {
        title: 'DoPay钱包-银行卡快捷充值'
      },
      component: () => import('@/views/dopay/rechargeBankQuick')
    },
    {
      path: 'dopay/rechargeB2B',
      name: 'rechargeB2B',
      meta: {
        title: 'DoPay钱包-B2B充值'
      },
      component: () => import('@/views/dopay/rechargeB2B')
    }, {
      path: 'dopay/openPage',
      name: 'openPage',
      meta: {
        title: '中转页面'
      },
      component: () => import('@/views/dopay/openPage')
    },
    {
      path: 'dopay/transfer',
      name: 'transfer',
      meta: {
        title: 'DoPay钱包-转账'
      },
      component: () => import('@/views/dopay/transfer')
    },
    {
      path: 'dopay/withdraw',
      name: 'withdraw',
      meta: {
        title: '提取余额到储蓄卡'
      },
      component: () => import('@/views/dopay/withdraw')
    }
  ]
}

export default doPayRouter
